import React, { ReactNode } from "react";

import * as S from "./Switch.styles";

export type LayoutProps = {
  disabled?: boolean;
  required?: boolean;
  checked?: boolean;
  label?: ReactNode;
  id?: string;
  onCheckedChange: (checked: boolean) => void;
};

const Switch = ({
  checked,
  onCheckedChange,
  required,
  label,
  disabled,
  id
}: LayoutProps) => {
  return (
    <S.Layout>
      {label && (
        <S.Label htmlFor={id} disabled={disabled}>
          {label}
        </S.Label>
      )}
      <S.Root
        id={id}
        disabled={disabled}
        checked={checked}
        required={required}
        onCheckedChange={onCheckedChange}
        aria-label="switch-failed-activities"
      >
        <S.Thumb />
      </S.Root>
    </S.Layout>
  );
};

export default Switch;
